import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { apiUrl } from "utils/api";
import bannerImage from "images/product.webp";
import reelImage from "images/reel.png";
import motionBoosterLogo from "images/Motion Booster White Logo-footer.svg";
import { fbTrack, getFbContext } from "utils/fbPixel";
import { getColorCode } from "utils/color";
import { Minus, Plus } from "lucide-react";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    ArrowRight,
    BadgeCheck,
    Bike,
    PartyPopper,
    ShieldCheck,
    Sparkles,
    Truck,
    Lightbulb,
    Youtube,
    Package,
    X,
} from "lucide-react";

const DEFAULT_CONFIG = {
    id: null,
    pageTitle: "",
    headline: "",
    subheadline: "",
    description: "",
    brandColor: "",
    bodyBgColor: "var(--nf-brand-50)",
    textColor: "var(--nf-brand-950)",
    mutedTextColor: "var(--nf-brand-700)",
    surfaceColor: "rgba(29, 78, 216, 0.10)",
    surfaceAltColor: "rgba(29, 78, 216, 0.18)",
    borderColor: "var(--nf-brand-200)",
    buttonColor: "var(--nf-brand-600)",
    buttonTextColor: "#ffffff",
    buttonSecondaryColor: "rgba(255, 255, 255, 0.08)",
    buttonSecondaryTextColor: "var(--nf-brand-950)",
    accentColor: "var(--nf-brand-600)",
    accentSoftColor: "var(--nf-brand-100)",
    heroTag: "",
    regularPriceLabel: "মূল্য",
    regularPriceAmount: "",
    regularPriceCurrencySymbol: "৳",
    offerPriceLabel: "অফার মূল্য",
    offerPriceAmount: "",
    offerPriceCurrencySymbol: "৳",
    orderNowLabel: "এখনই অর্ডার করুন",
    orderNowHref: "/confirmOrder",
    secondaryActionHref: "/contactUs",
    imageUrl: "",
    bannerSectionTitle: "",
    bannerSectionSubtitle: "Fresh offers and highlights from the catalog.",
    mediaSectionBadge: "Why Customers Trust Us",
    mediaSectionTitle: "A polished buying experience, built to convert",
    mediaSectionSubtitle:
        "Clear product storytelling, strong trust signals, and a responsive layout that feels premium on any device.",
    mediaSectionImage: reelImage,
    mediaSectionVideoLabel: "Watch Product Demo",
    mediaSectionVideoUrl: "",
    videoFeatureCards: [],
    bulletCaption: "Read First",
    bulletTitle: "",
    bulletSubtitle: "",
    bulletMainImagePath: "",
    bulletPoints: [],
    secretTipIconName: "",
    secretTipTitle: "",
    secretTipDescription: "",
    whatsappPhone: "",
    whatsappMessage: "",
    checkoutCaption: "Order Details",
    checkoutTitle: "Checkout",
    checkoutSubtitle: "",
    checkoutProductImagePath: "",
    checkoutImages: [],
    checkoutProductName: "",
    checkoutProductSubname: "",
    checkoutPrice: "1,999",
    checkoutDeliveryOptionsText: "ডেলিভারি এরিয়া *",
    checkoutBottomRowsText:
        "",
    checkoutButtonText: "",
    faqCaption: "প্রশ্ন আছে?",
    faqTitle: "সচারচর জিজ্ঞাসা",
    faqs: [],

    orderFormBadge: "Order Form",
    orderFormTitle: "মাত্র ৩টি তথ্য দিয়ে অর্ডার সম্পন্ন করুন",
    orderFormSubtitle:
        "স্বচ্ছ মূল্য, দ্রুত ডেলিভারি, আর মোবাইল-ফ্রেন্ডলি ফর্মের মাধ্যমে আরও সহজ অর্ডার অভিজ্ঞতা।",
    orderFormProductName: "",
    orderFormProductDescription:
        "",
    orderFormNameLabel: "আপনার নাম *",
    orderFormNamePlaceholder: "উদাহরণ: রহিম উদ্দিন",
    orderFormPhoneLabel: "মোবাইল নাম্বার *",
    orderFormPhonePlaceholder: "01XXXXXXXXX",
    orderFormQuantityLabel: "পরিমাণ*",
    orderFormDeliveryLabel: "ডেলিভারি এরিয়া *",
    orderFormInsideLabel: "ঢাকার ভিতরে",
    orderFormOutsideLabel: "ঢাকার বাইরে",
    orderFormAddressLabel: "সম্পূর্ণ ঠিকানা *",
    orderFormAddressPlaceholder: "বাসা/রোড, এলাকা, থানা, জেলা",
    orderFormCouponLabel: "ক্যাশ অন ডেলিভারি",
    orderFormCouponPlaceholder: "প্রোমো কোড (ঐচ্ছিক)",
    orderFormCouponButtonLabel: "Apply",
    orderFormCtaLabel: "অর্ডার কনফার্ম করুন",
    orderFormCtaHref: "/confirmOrder",
    orderFormSupportLabel: "দ্রুত সহায়তা",
    orderFormSupportValue: "সাপোর্ট টিম ২৪/৭ প্রস্তুত",
    orderFormInsideFeeLabel: "ঢাকার ভিতরে ডেলিভারি",
    orderFormOutsideFeeLabel: "ঢাকার বাইরে ডেলিভারি",
    orderFormInsideFeeValue: "80",
    orderFormOutsideFeeValue: "150",
    orderFormNote:
        "ফর্মটি আপনার অর্ডারকে দ্রুত যাচাই ও কনফার্ম করতে ব্যবহার করা হবে।",
    offerSectionBadge: "",
    offerSectionTitle: "",
    offerSectionSubtitle:
        "",
    offerSectionItems: [],
    offerSectionCtaLabel: "Order Now",
    offerSectionCtaHref: "/confirmOrder",
    offerSectionCountdownTitle: "Offer ends in",
    offerSectionCountdown: [
        { value: "00", label: "D" },
        { value: "00", label: "H" },
        { value: "00", label: "M" },
        { value: "00", label: "S" },
    ],
    offerSectionFeatures: [],
    bannerImages: [],
    comboImages: [],
};

const isRenderableColor = (value) => {
    if (!value || typeof value !== "string") return false;
    if (typeof CSS !== "undefined" && CSS.supports) {
        return (
            CSS.supports("color", value) || CSS.supports("background-color", value)
        );
    }
    return true;
};

const pickColor = (...values) => {
    const found = values.find((value) => isRenderableColor(value));
    return found || "";
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const normalizeHexColor = (color) => {
    if (typeof color !== "string") return "";

    const trimmed = color.trim();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(trimmed)) {
        if (trimmed.length === 4) {
            const [, r, g, b] = trimmed;
            return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
        }

        return trimmed.toLowerCase();
    }

    const mappedColor = getColorCode(trimmed);
    if (/^#([0-9a-f]{6})$/i.test(mappedColor)) {
        return mappedColor.toLowerCase();
    }

    return "";
};

const hexToRgb = (hex) => {
    const normalized = normalizeHexColor(hex);
    if (!normalized) return null;

    const value = normalized.slice(1);
    const numeric = Number.parseInt(value, 16);
    return {
        r: (numeric >> 16) & 255,
        g: (numeric >> 8) & 255,
        b: numeric & 255,
    };
};

const rgbToHex = ({ r, g, b }) =>
    `#${[r, g, b]
        .map((channel) =>
            clamp(Math.round(channel), 0, 255).toString(16).padStart(2, "0"),
        )
        .join("")}`;

const mixHexColors = (baseColor, mixColor, weight) => {
    const baseRgb = hexToRgb(baseColor);
    const mixRgb = hexToRgb(mixColor);

    if (!baseRgb || !mixRgb) {
        return normalizeHexColor(baseColor) || baseColor;
    }

    const blend = clamp(weight, 0, 1);
    return rgbToHex({
        r: baseRgb.r + (mixRgb.r - baseRgb.r) * blend,
        g: baseRgb.g + (mixRgb.g - baseRgb.g) * blend,
        b: baseRgb.b + (mixRgb.b - baseRgb.b) * blend,
    });
};

const hexToRgba = (hex, alpha) => {
    const rgb = hexToRgb(hex);
    if (!rgb) return hex;

    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${clamp(alpha, 0, 1)})`;
};

const buildBrandColorScale = (brandColor) => {
    const baseColor = normalizeHexColor(brandColor) || DEFAULT_CONFIG.brandColor;

    return {
        50: mixHexColors(baseColor, "#ffffff", 0.94),
        100: mixHexColors(baseColor, "#ffffff", 0.84),
        200: mixHexColors(baseColor, "#ffffff", 0.68),
        300: mixHexColors(baseColor, "#ffffff", 0.48),
        400: mixHexColors(baseColor, "#ffffff", 0.28),
        500: baseColor,
        600: mixHexColors(baseColor, "#000000", 0.1),
        700: mixHexColors(baseColor, "#000000", 0.22),
        800: mixHexColors(baseColor, "#000000", 0.36),
        900: mixHexColors(baseColor, "#000000", 0.52),
        950: mixHexColors(baseColor, "#000000", 0.7),
    };
};

const BRAND_SHADE_KEYS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

const isExternalHref = (href) =>
    typeof href === "string" &&
    /^(https?:|mailto:|tel:|sms:|whatsapp:)/i.test(href);

const ActionLink = ({ href, className, style, children }) => {
    if (isExternalHref(href)) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className={className}
                style={style}
            >
                {children}
            </a>
        );
    }

    return (
        <Link to={href} className={className} style={style}>
            {children}
        </Link>
    );
};

const hasText = (value) =>
    typeof value === "string" ? value.trim().length > 0 : value != null;

const toAbsoluteMediaUrl = (value) => {
    if (!hasText(value)) return "";

    const stringValue = String(value).trim();
    if (/^https?:\/\//i.test(stringValue)) {
        return stringValue;
    }

    return apiUrl(stringValue.replace(/^\/+/, ""));
};

const normalizeArrayValue = (value) => (Array.isArray(value) ? value : []);

const splitColorNames = (value) =>
    typeof value === "string"
        ? value
            .split(",")
            .map((part) => part.trim())
            .filter(Boolean)
        : [];

const getSwatchBackground = (colorNames) => {
    if (colorNames.length <= 1) {
        return getColorCode(colorNames[0] || "");
    }

    const codes = colorNames.map((name) => getColorCode(name));
    const step = 100 / codes.length;
    const stops = codes
        .map(
            (code, index) => `${code} ${index * step}% ${(index + 1) * step}%`,
        )
        .join(", ");

    return `linear-gradient(90deg, ${stops})`;
};

const BANGLA_DIGITS = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

const toBanglaDigits = (value) => {
    if (value === null || value === undefined) return value;

    return String(value).replace(/[0-9]/g, (digit) => BANGLA_DIGITS[digit]);
};

const parseCountdownTarget = (value) => {
    if (value instanceof Date) return value;
    if (typeof value !== "string" || !value.trim()) return null;

    const trimmed = value.trim();
    const localTimestamp = trimmed.replace(/Z$/i, "").replace(/\.\d{3,}$/, "");
    const targetDate = new Date(localTimestamp);

    return Number.isNaN(targetDate.getTime()) ? null : targetDate;
};

const getCountdownParts = (targetDate) => {
    const targetTime = targetDate instanceof Date ? targetDate.getTime() : NaN;
    if (!Number.isFinite(targetTime)) return null;

    const remaining = targetTime - Date.now();
    if (remaining <= 0) {
        return {
            days: "00",
            hours: "00",
            minutes: "00",
            seconds: "00",
            expired: true,
        };
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
        expired: false,
    };
};

const getYoutubeEmbedUrl = (url) => {
    if (typeof url !== "string" || !url.trim()) return "";

    const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|shorts\/|watch\?v=|watch\?.*&v=))([\w-]{11})/,
    );

    return match ? `https://www.youtube.com/embed/${match[1]}?autoplay=1` : "";
};

const resolveLucideIcon = (iconName, fallback = ShieldCheck) => {
    if (typeof iconName !== "string" || !iconName.trim()) return fallback;

    const iconKey = iconName
        .split("-")
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("");

    return LucideIcons[iconKey] || fallback;
};

const normalizeLandingPageConfig = (payload) => {
    const source = Array.isArray(payload) ? payload[0] || {} : payload || {};
    const colors = source.colors || {};
    const actions = source.actions || {};
    const bannerImagesSource = normalizeArrayValue(
        source.banner_images || source.bannerImages,
    );
    const miniFeatureCardsSource = normalizeArrayValue(
        source.mini_feature_cards || source.miniFeatureCards,
    );
    const videoFeatureCardsSource = normalizeArrayValue(
        source.video_feature_cards || source.videoFeatureCards,
    );
    const bulletPointsSource = normalizeArrayValue(
        source.bullet_points || source.bulletPoints,
    );
    const specRowsSource = normalizeArrayValue(
        source.spec_rows || source.specRows,
    );
    const checkoutImagesSource = normalizeArrayValue(
        source.checkout_images || source.checkoutImages,
    );
    const comboImagesSource = normalizeArrayValue(
        source.combo_images || source.comboImages,
    );
    const faqsSource = normalizeArrayValue(source.faqs);
    const brandColor = pickColor(
        source.palette_color,
        source.brandColor,
        source.primaryColor,
        colors.brandColor,
        colors.primaryColor,
        DEFAULT_CONFIG.brandColor,
    );
    const brandColorScale = buildBrandColorScale(brandColor);

    const config = {
        ...DEFAULT_CONFIG,
        ...source,
        pageTitle:
            source.pageTitle ||
            source.page_title ||
            source.title ||
            DEFAULT_CONFIG.pageTitle,
        headline:
            source.headline ||
            source.hero_title ||
            source.heading ||
            DEFAULT_CONFIG.headline,
        subheadline:
            source.subheadline ||
            source.hero_subtitle ||
            source.subtitle ||
            DEFAULT_CONFIG.subheadline,
        description:
            source.description ||
            source.hero_description ||
            DEFAULT_CONFIG.description,
        brandColor,
        bodyBgColor: pickColor(
            source.bodyBgColor,
            source.backgroundColor,
            colors.bodyBgColor,
            colors.backgroundColor,
            `var(--nf-brand-50)`,
        ),
        textColor: pickColor(
            source.textColor,
            source.headingColor,
            colors.textColor,
            colors.headingColor,
            `var(--nf-brand-950)`,
        ),
        mutedTextColor: pickColor(
            source.mutedTextColor,
            source.secondaryTextColor,
            colors.mutedTextColor,
            colors.secondaryTextColor,
            `var(--nf-brand-700)`,
        ),
        surfaceColor: pickColor(
            source.surfaceColor,
            colors.surfaceColor,
            hexToRgba(brandColorScale[950], 0.1),
        ),
        surfaceAltColor: pickColor(
            source.surfaceAltColor,
            colors.surfaceAltColor,
            hexToRgba(brandColorScale[950], 0.18),
        ),
        borderColor: pickColor(
            source.borderColor,
            colors.borderColor,
            `var(--nf-brand-200)`,
        ),
        buttonColor: pickColor(
            source.buttonColor,
            source.primaryColor,
            actions.primaryColor,
            colors.buttonColor,
            colors.primaryColor,
            `var(--nf-brand-600)`,
        ),
        buttonTextColor: pickColor(
            source.buttonTextColor,
            actions.primaryTextColor,
            colors.buttonTextColor,
            DEFAULT_CONFIG.buttonTextColor,
        ),
        buttonSecondaryColor: pickColor(
            source.buttonSecondaryColor,
            source.secondaryColor,
            actions.secondaryColor,
            colors.buttonSecondaryColor,
            colors.secondaryColor,
            hexToRgba(brandColorScale[500], 0.08),
        ),
        buttonSecondaryTextColor: pickColor(
            source.buttonSecondaryTextColor,
            actions.secondaryTextColor,
            colors.buttonSecondaryTextColor,
            `var(--nf-brand-950)`,
        ),
        accentColor: pickColor(
            source.accentColor,
            colors.accentColor,
            `var(--nf-brand-600)`,
        ),
        accentSoftColor: pickColor(
            source.accentSoftColor,
            colors.accentSoftColor,
            `var(--nf-brand-100)`,
        ),
        heroTag:
            source.heroTag ||
            source.hero_caption ||
            source.heroCaption ||
            DEFAULT_CONFIG.heroTag,
        regularPriceLabel:
            source.regularPriceLabel || DEFAULT_CONFIG.regularPriceLabel,
        regularPriceAmount:
            source.hero_regular_price ||
            source.heroRegularPrice ||
            source.regularPriceAmount ||
            DEFAULT_CONFIG.regularPriceAmount,
        regularPriceCurrencySymbol:
            source.regularPriceCurrencySymbol ||
            DEFAULT_CONFIG.regularPriceCurrencySymbol,
        offerPriceLabel: source.offerPriceLabel || DEFAULT_CONFIG.offerPriceLabel,
        offerPriceAmount:
            source.hero_offer_price ||
            source.heroOfferPrice ||
            source.offerPriceAmount ||
            DEFAULT_CONFIG.offerPriceAmount,
        offerPriceCurrencySymbol:
            source.offerPriceCurrencySymbol ||
            DEFAULT_CONFIG.offerPriceCurrencySymbol,
        orderNowLabel:
            source.hero_button_text ||
            source.heroButtonText ||
            actions.orderNowLabel ||
            source.orderNowLabel ||
            DEFAULT_CONFIG.orderNowLabel,
        orderNowHref:
            actions.orderNowHref ||
            source.orderNowHref ||
            DEFAULT_CONFIG.orderNowHref,

        secondaryActionHref:
            actions.secondaryHref ||
            source.secondaryActionHref ||
            DEFAULT_CONFIG.secondaryActionHref,
        imageUrl:
            toAbsoluteMediaUrl(
                source.imageUrl ||
                source.heroImage ||
                source.hero_image_path ||
                source.bannerImage ||
                source.banner_image_path,
            ) || DEFAULT_CONFIG.imageUrl,
        heroImagePath:
            source.hero_image_path ||
            source.heroImagePath ||
            source.imageUrl ||
            source.heroImage ||
            "",
        bannerSectionTitle: source.bannerSectionTitle || "Banner Slider Images",
        bannerSectionSubtitle:
            source.bannerSectionSubtitle || DEFAULT_CONFIG.bannerSectionSubtitle,
        mediaSectionBadge:
            source.mediaSectionBadge ||
            source.video_caption ||
            DEFAULT_CONFIG.mediaSectionBadge,
        mediaSectionTitle:
            source.mediaSectionTitle ||
            source.video_title ||
            DEFAULT_CONFIG.mediaSectionTitle,
        mediaSectionSubtitle:
            source.mediaSectionSubtitle ||
            source.video_subtitle ||
            DEFAULT_CONFIG.mediaSectionSubtitle,
        mediaSectionImage:
            toAbsoluteMediaUrl(
                source.mediaSectionImage ||
                source.mediaImage ||
                source.video_thumbnail_path ||
                source.videoThumbnailPath ||
                source.thumbnail_path,
            ) || DEFAULT_CONFIG.mediaSectionImage,
        mediaSectionVideoLabel:
            source.mediaSectionVideoLabel || DEFAULT_CONFIG.mediaSectionVideoLabel,
        mediaSectionVideoUrl:
            source.mediaSectionVideoUrl ||
            source.video_youtube_url ||
            source.mediaVideoUrl ||
            DEFAULT_CONFIG.mediaSectionVideoUrl,
        heroCountdownAt: source.hero_countdown_at || source.heroCountdownAt || "",
        videoFeatureCards: videoFeatureCardsSource.map((item) => ({
            id: item.id,
            iconName: item.icon_name || item.iconName || "",
            title: item.title || "",
            subtitle: item.subtitle || "",
        })),
        bulletCaption:
            source.bullet_caption ||
            source.bulletCaption ||
            DEFAULT_CONFIG.bannerSectionTitle,
        bulletTitle:
            source.bullet_title ||
            source.bulletTitle ||
            DEFAULT_CONFIG.offerSectionTitle,
        bulletSubtitle:
            source.bullet_subtitle ||
            source.bulletSubtitle ||
            DEFAULT_CONFIG.offerSectionSubtitle,
        bulletMainImagePath:
            source.bullet_main_image_path || source.bulletMainImagePath || "",
        bulletPoints: bulletPointsSource.map((item) => ({
            id: item.id,
            pointText: item.point_text || item.pointText || "",
        })),
        secretTipIconName:
            source.secret_tip_icon_name || source.secretTipIconName || "",
        secretTipTitle: source.secret_tip_title || source.secretTipTitle || "",
        secretTipDescription:
            source.secret_tip_description || source.secretTipDescription || "",
        whatsappPhone: source.whatsapp_phone || source.whatsappPhone || "",
        whatsappMessage: source.whatsapp_message || source.whatsappMessage || "",
        checkoutCaption:
            source.checkout_form_caption ||
            source.checkoutCaption ||
            DEFAULT_CONFIG.offerSectionBadge,
        checkoutTitle:
            source.checkout_form_title ||
            source.checkoutTitle ||
            DEFAULT_CONFIG.offerSectionTitle,
        checkoutSubtitle:
            source.checkout_form_subtitle ||
            source.checkoutSubtitle ||
            DEFAULT_CONFIG.offerSectionSubtitle,
        checkoutProductImagePath:
            source.checkout_product_image_path ||
            source.checkoutProductImagePath ||
            "",
        checkoutImages: checkoutImagesSource
            .slice()
            .sort(
                (a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0),
            )
            .map((item, index) => ({
                id: item.id ?? index,
                imagePath: item.image_path || item.imagePath || "",
                src: toAbsoluteMediaUrl(item.image_path || item.imagePath),
                color: item.color || "",
                colors: splitColorNames(item.color),
            })),
        checkoutProductName:
            source.checkout_product_name ||
            source.checkoutProductName ||
            DEFAULT_CONFIG.orderFormProductName,
        checkoutProductSubname:
            source.checkout_product_subname ||
            source.checkoutProductSubname ||
            DEFAULT_CONFIG.orderFormProductDescription,
        checkoutPrice:
            source.checkout_price ||
            source.checkoutPrice ||
            DEFAULT_CONFIG.offerPriceAmount,
        checkoutDeliveryOptionsText:
            source.checkout_delivery_options_text ||
            source.checkoutDeliveryOptionsText ||
            DEFAULT_CONFIG.orderFormDeliveryLabel,
        checkoutBottomRowsText:
            source.checkout_bottom_rows_text || source.checkoutBottomRowsText || "",
        checkoutButtonText:
            source.checkout_button_text || source.checkoutButtonText || "",
        faqCaption:
            source.faq_caption || source.faqCaption || DEFAULT_CONFIG.faqCaption,
        faqTitle: source.faq_title || source.faqTitle || DEFAULT_CONFIG.faqTitle,

        orderFormBadge: source.orderFormBadge || DEFAULT_CONFIG.orderFormBadge,
        orderFormTitle: source.orderFormTitle || DEFAULT_CONFIG.orderFormTitle,
        orderFormSubtitle:
            source.orderFormSubtitle || DEFAULT_CONFIG.orderFormSubtitle,
        orderFormProductName:
            source.orderFormProductName || DEFAULT_CONFIG.orderFormProductName,
        orderFormProductDescription:
            source.orderFormProductDescription ||
            DEFAULT_CONFIG.orderFormProductDescription,
        orderFormNameLabel:
            source.orderFormNameLabel || DEFAULT_CONFIG.orderFormNameLabel,
        orderFormNamePlaceholder:
            source.orderFormNamePlaceholder ||
            DEFAULT_CONFIG.orderFormNamePlaceholder,
        orderFormPhoneLabel:
            source.orderFormPhoneLabel || DEFAULT_CONFIG.orderFormPhoneLabel,
        orderFormPhonePlaceholder:
            source.orderFormPhonePlaceholder ||
            DEFAULT_CONFIG.orderFormPhonePlaceholder,
        orderFormQuantityLabel:
            source.orderFormQuantityLabel || DEFAULT_CONFIG.orderFormQuantityLabel,
        orderFormDeliveryLabel:
            source.orderFormDeliveryLabel || DEFAULT_CONFIG.orderFormDeliveryLabel,
        orderFormInsideLabel:
            source.orderFormInsideLabel || DEFAULT_CONFIG.orderFormInsideLabel,
        orderFormOutsideLabel:
            source.orderFormOutsideLabel || DEFAULT_CONFIG.orderFormOutsideLabel,
        orderFormAddressLabel:
            source.orderFormAddressLabel || DEFAULT_CONFIG.orderFormAddressLabel,
        orderFormAddressPlaceholder:
            source.orderFormAddressPlaceholder ||
            DEFAULT_CONFIG.orderFormAddressPlaceholder,
        orderFormCouponLabel:
            source.orderFormCouponLabel || DEFAULT_CONFIG.orderFormCouponLabel,
        orderFormCouponPlaceholder:
            source.orderFormCouponPlaceholder ||
            DEFAULT_CONFIG.orderFormCouponPlaceholder,
        orderFormCouponButtonLabel:
            source.orderFormCouponButtonLabel ||
            DEFAULT_CONFIG.orderFormCouponButtonLabel,
        orderFormCtaLabel:
            source.orderFormCtaLabel || DEFAULT_CONFIG.orderFormCtaLabel,
        orderFormCtaHref:
            source.orderFormCtaHref || DEFAULT_CONFIG.orderFormCtaHref,
        orderFormSupportLabel:
            source.orderFormSupportLabel || DEFAULT_CONFIG.orderFormSupportLabel,
        orderFormSupportValue:
            source.orderFormSupportValue || DEFAULT_CONFIG.orderFormSupportValue,
        orderFormInsideFeeLabel:
            source.orderFormInsideFeeLabel || DEFAULT_CONFIG.orderFormInsideFeeLabel,
        orderFormOutsideFeeLabel:
            source.orderFormOutsideFeeLabel ||
            DEFAULT_CONFIG.orderFormOutsideFeeLabel,
        orderFormInsideFeeValue:
            source.orderFormInsideFeeValue || DEFAULT_CONFIG.orderFormInsideFeeValue,
        orderFormOutsideFeeValue:
            source.orderFormOutsideFeeValue ||
            DEFAULT_CONFIG.orderFormOutsideFeeValue,
        orderFormNote: source.orderFormNote || DEFAULT_CONFIG.orderFormNote,
        offerSectionBadge:
            source.offerSectionBadge ||
            source.checkout_caption ||
            source.checkoutCaption ||
            DEFAULT_CONFIG.offerSectionBadge,
        offerSectionTitle:
            source.offerSectionTitle ||
            source.spec_title ||
            source.checkout_title ||
            DEFAULT_CONFIG.offerSectionTitle,
        offerSectionSubtitle:
            source.offerSectionSubtitle ||
            source.spec_subtitle ||
            source.checkout_subtitle ||
            DEFAULT_CONFIG.offerSectionSubtitle,
        offerSectionItems: specRowsSource.map((item) => ({
            label: item.spec_key || item.specKey || "",
            value: item.spec_value || item.specValue || "",
        })),
        offerSectionCtaLabel:
            source.offerSectionCtaLabel || DEFAULT_CONFIG.offerSectionCtaLabel,
        offerSectionCtaHref:
            source.offerSectionCtaHref || DEFAULT_CONFIG.offerSectionCtaHref,
        offerSectionCountdownTitle:
            source.offerSectionCountdownTitle ||
            DEFAULT_CONFIG.offerSectionCountdownTitle,
        offerSectionCountdown:
            normalizeArrayValue(source.offerSectionCountdown).length > 0
                ? source.offerSectionCountdown
                : DEFAULT_CONFIG.offerSectionCountdown,
        offerSectionFeatures: miniFeatureCardsSource.map((item) => ({
            title: item.title || item.name || "",
            iconName: item.icon_name || item.iconName || "",
            icon: resolveLucideIcon(item.icon_name || item.iconName || "", Truck),
        })),
        bannerImages:
            bannerImagesSource.length > 0
                ? bannerImagesSource.map((item, index) => ({
                    src: toAbsoluteMediaUrl(
                        item?.src ||
                        item?.image ||
                        item?.image_path ||
                        item?.path ||
                        item?.url,
                    ),
                    alt: item?.alt || `Banner ${index + 1}`,
                }))
                : [],
        faqs: faqsSource.map((item) => ({
            question: item.question || "",
            answer: item.answer || "",
        })),
        comboImages: comboImagesSource
            .slice()
            .sort(
                (a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0),
            )
            .map((item, index) => ({
                id: item.id ?? index,
                src: toAbsoluteMediaUrl(item.image_path || item.imagePath),
                title: item.title || "",
                shortNote: item.short_note || item.shortNote || "",
            })),
    };

    return config;
};

const LandingPage = () => {
    const { slug } = useParams();
    const resolvedSlug = typeof slug === "string" ? slug.trim() : "";
    const [config, setConfig] = useState(DEFAULT_CONFIG);
    const [orderQuantity, setOrderQuantity] = useState(1);
    const [deliveryArea, setDeliveryArea] = useState("inside");
    const [customerName, setCustomerName] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerAddress, setCustomerAddress] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [orderFormErrors, setOrderFormErrors] = useState({});
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
    const [orderSubmitStatus, setOrderSubmitStatus] = useState(null);
    const [showOrderConfirmModal, setShowOrderConfirmModal] = useState(false);
    const [comboZoomImage, setComboZoomImage] = useState(null);
    const carouselRef = useRef(null);
    const [activeBannerIndex, setActiveBannerIndex] = useState(0);

    const pageStyles = useMemo(
        () => ({
            backgroundColor: config.bodyBgColor,
            color: config.textColor,
            minHeight: "100vh",
        }),
        [config.bodyBgColor, config.textColor],
    );
    const brandColorScale = useMemo(
        () => buildBrandColorScale(config.brandColor),
        [config.brandColor],
    );
    const orderFormTheme = useMemo(
        () => ({
            sectionBg: brandColorScale[950],
            sectionText: brandColorScale[50],
            badgeBg: brandColorScale[300],
            badgeText: brandColorScale[950],
            cardBg: brandColorScale[50],
            cardBorder: brandColorScale[200],
            cardShadow: `0 30px 90px ${hexToRgba(brandColorScale[950], 0.22)}`,
            panelBg: "#ffffff",
            panelBorder: brandColorScale[200],
            headingText: brandColorScale[950],
            bodyText: brandColorScale[700],
            priceText: brandColorScale[700],
            priceAccent: brandColorScale[600],
            inputBorder: brandColorScale[200],
            inputFocus: brandColorScale[600],
            inputText: brandColorScale[950],
            inputPlaceholder: brandColorScale[400],
            optionSelectedBg: brandColorScale[100],
            optionSelectedBorder: brandColorScale[600],
            optionSelectedDot: brandColorScale[600],
            optionDefaultBorder: brandColorScale[200],
            optionDefaultText: brandColorScale[700],
            optionDefaultDot: brandColorScale[400],
            couponBg: brandColorScale[50],
            couponBorder: brandColorScale[200],
            couponText: brandColorScale[800],
            summaryBg: brandColorScale[950],
            summaryText: brandColorScale[50],
            summaryMutedText: brandColorScale[100],
            summaryDivider: hexToRgba(brandColorScale[50], 0.12),
            summaryAccent: brandColorScale[300],
            buttonColor: brandColorScale[300],
            ctaFrom: brandColorScale[600],
            ctaTo: brandColorScale[700],
        }),
        [brandColorScale],
    );
    const itemSectionTheme = useMemo(
        () => ({
            sectionBg: brandColorScale[50],
            sectionBorder: brandColorScale[200],
            sectionShadow: `0 20px 60px ${hexToRgba(brandColorScale[950], 0.08)}`,
            badgeBg: brandColorScale[100],
            badgeText: brandColorScale[950],
            headingText: brandColorScale[950],
            bodyText: brandColorScale[700],
            listBg: "#ffffff",
            listBorder: brandColorScale[200],
            rowBorder: brandColorScale[100],
            stepBg: brandColorScale[100],
            stepText: brandColorScale[700],
            itemText: brandColorScale[900],
            valueText: brandColorScale[600],
            totalBg: brandColorScale[100],
            totalText: brandColorScale[700],
            totalValueText: brandColorScale[950],
            summaryBg: brandColorScale[950],
            summaryText: brandColorScale[50],
            summaryMutedText: brandColorScale[100],
            summaryDivider: hexToRgba(brandColorScale[50], 0.12),
            summaryAccent: brandColorScale[300],
            ctaFrom: brandColorScale[600],
            ctaTo: brandColorScale[700],
            featureCardBg: "#ffffff",
            featureCardBorder: brandColorScale[200],
            featureIconBg: brandColorScale[100],
            featureIconText: brandColorScale[700],
            featureText: brandColorScale[50],
        }),
        [brandColorScale],
    );

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const previousBodyStyles = {
            backgroundColor: document.body.style.backgroundColor,
            color: document.body.style.color,
            minHeight: document.body.style.minHeight,
            transition: document.body.style.transition,
        };

        const previousHtmlBackground =
            document.documentElement.style.backgroundColor;
        const previousBrandVars = {};

        const applyBodyStyles = (nextConfig) => {
            const brandColorScale = buildBrandColorScale(nextConfig.brandColor);

            BRAND_SHADE_KEYS.forEach((shade) => {
                const varName = `--nf-brand-${shade}`;
                previousBrandVars[varName] =
                    document.documentElement.style.getPropertyValue(varName);
                document.documentElement.style.setProperty(
                    varName,
                    brandColorScale[shade],
                );
            });

            document.body.style.backgroundColor = nextConfig.bodyBgColor;
            document.body.style.color = nextConfig.textColor;
            document.body.style.minHeight = "100vh";
            document.body.style.transition =
                "background-color 0.25s ease, color 0.25s ease";
            document.documentElement.style.backgroundColor = nextConfig.bodyBgColor;
        };

        const fetchLandingPage = async () => {
            if (!resolvedSlug) {
                if (!isMounted) return;
                applyBodyStyles(DEFAULT_CONFIG);
                setConfig(DEFAULT_CONFIG);
                return;
            }

            try {
                const response = await fetch(
                    apiUrl(`api/landing-pages/${encodeURIComponent(resolvedSlug)}`),
                    {
                        signal: controller.signal,
                    },
                );
                if (!response.ok) {
                    throw new Error(
                        `Landing page request failed with ${response.status}`,
                    );
                }

                const data = await response.json();
                const payload =
                    data &&
                    typeof data === "object" &&
                    data.data &&
                    !Array.isArray(data.data)
                        ? data.data
                        : data;
                const nextConfig = normalizeLandingPageConfig(payload);

                if (!isMounted) return;
                setConfig(nextConfig);
                applyBodyStyles(nextConfig);
            } catch (error) {
                if (!isMounted || error?.name === "AbortError") return;
                applyBodyStyles(DEFAULT_CONFIG);
                setConfig(DEFAULT_CONFIG);
            }
        };

        applyBodyStyles(DEFAULT_CONFIG);
        fetchLandingPage();

        return () => {
            isMounted = false;
            controller.abort();
            BRAND_SHADE_KEYS.forEach((shade) => {
                const varName = `--nf-brand-${shade}`;
                document.documentElement.style.setProperty(
                    varName,
                    previousBrandVars[varName] || "",
                );
            });
            document.body.style.backgroundColor = previousBodyStyles.backgroundColor;
            document.body.style.color = previousBodyStyles.color;
            document.body.style.minHeight = previousBodyStyles.minHeight;
            document.body.style.transition = previousBodyStyles.transition;
            document.documentElement.style.backgroundColor = previousHtmlBackground;
        };
    }, [resolvedSlug]);

    const surfaceAltStyle = {
        backgroundColor: config.surfaceAltColor,
        borderColor: config.borderColor,
        color: config.textColor,
    };
    const primaryButtonStyle = {
        backgroundColor: config.buttonColor,
        color: config.buttonTextColor,
    };

    const heroImage = config.imageUrl || bannerImage;
    const mediaImage = config.mediaSectionImage || reelImage;
    const bannerCards = config.bannerImages || [];
    const bannerCount = bannerCards.length;
    const { language } = useSettings();
    const [heroCountdownParts, setHeroCountdownParts] = useState(null);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const youtubeEmbedUrl = getYoutubeEmbedUrl(config.mediaSectionVideoUrl);
    const bulletMainImage = toAbsoluteMediaUrl(config.bulletMainImagePath);
    const checkoutImages = normalizeArrayValue(config.checkoutImages);
    const comboImages = normalizeArrayValue(config.comboImages);
    const checkoutColorOptions = useMemo(() => {
        const seen = new Map();
        checkoutImages.forEach((item) => {
            const raw = item.color?.trim();
            if (!raw) return;
            const key = raw.toLowerCase();
            if (!seen.has(key)) seen.set(key, raw);
        });
        return Array.from(seen.values());
    }, [checkoutImages]);
    const selectedCheckoutImage = useMemo(() => {
        if (checkoutImages.length === 0) return null;
        if (selectedImageId != null) {
            const byId = checkoutImages.find((item) => item.id === selectedImageId);
            if (byId) return byId;
        }
        if (selectedColor) {
            const match = checkoutImages.find(
                (item) =>
                    item.color?.trim().toLowerCase() === selectedColor.toLowerCase(),
            );
            if (match) return match;
        }
        return checkoutImages[0];
    }, [checkoutImages, selectedImageId, selectedColor]);
    const selectCheckoutColor = (color) => {
        setSelectedColor(color);
        const match = checkoutImages.find(
            (item) => item.color?.trim().toLowerCase() === color.toLowerCase(),
        );
        if (match) setSelectedImageId(match.id);
    };
    const selectCheckoutImage = (item) => {
        setSelectedImageId(item.id);
        if (item.color?.trim()) {
            setSelectedColor(item.color.trim());
        }
    };
    const checkoutProductImage =
        toAbsoluteMediaUrl(config.checkoutProductImagePath) || heroImage;
    const videoFeatureCards = normalizeArrayValue(config.videoFeatureCards);
    const bulletPoints = normalizeArrayValue(config.bulletPoints);
    const SecretTipIcon = resolveLucideIcon(config.secretTipIconName, Lightbulb);
    const faqCards = Array.isArray(config.faqs) ? config.faqs : [];

    const parsedOfferPrice =
        Number(String(config.offerPriceAmount).replace(/[^0-9.]/g, "")) || 0;
    const parsedRegularPrice =
        Number(String(config.regularPriceAmount).replace(/[^0-9.]/g, "")) || 0;
    const heroSavingsAmount =
        parsedRegularPrice > parsedOfferPrice
            ? parsedRegularPrice - parsedOfferPrice
            : 0;
    useEffect(() => {
        if (!config.id) return;

        fbTrack("ViewContent", {
            content_ids: [String(config.id)],
            content_type: "product",
            content_name: config.checkoutProductName || config.headline,
            currency: "BDT",
            value: parsedOfferPrice,
        });
    }, [config.id]);

    const isFreeDelivery =
        config.checkoutDeliveryOptionsText.trim().toLowerCase() ===
        "free delivery";
    const deliveryInsideFee = isFreeDelivery
        ? 0
        : Number(String(config.orderFormInsideFeeValue).replace(/[^0-9.]/g, "")) ||
        0;
    const deliveryOutsideFee = isFreeDelivery
        ? 0
        : Number(
        String(config.orderFormOutsideFeeValue).replace(/[^0-9.]/g, ""),
    ) || 0;
    const deliveryFee =
        deliveryArea === "outside" ? deliveryOutsideFee : deliveryInsideFee;
    const orderSubtotal = parsedOfferPrice * orderQuantity;
    const orderTotal = orderSubtotal + deliveryFee;
    const formatPrice = (value) =>
        new Intl.NumberFormat("en-US").format(Number.isFinite(value) ? value : 0);
    const whatsappDigits = config.whatsappPhone.replace(/[^0-9]/g, "");
    const whatsappNumber = whatsappDigits.startsWith("880")
        ? whatsappDigits
        : whatsappDigits.startsWith("0")
            ? `880${whatsappDigits.slice(1)}`
            : whatsappDigits;
    const whatsappHref = whatsappNumber
        ? `https://wa.me/${whatsappNumber}${
            config.whatsappMessage
                ? `?text=${encodeURIComponent(config.whatsappMessage)}`
                : ""
        }`
        : "";

    useEffect(() => {
        if (checkoutColorOptions.length === 0) {
            setSelectedColor("");
            return;
        }

        setSelectedColor((current) =>
            current &&
            checkoutColorOptions.some(
                (color) => color.toLowerCase() === current.toLowerCase(),
            )
                ? current
                : checkoutColorOptions[0],
        );
    }, [checkoutColorOptions]);

    useEffect(() => {
        setSelectedImageId((current) =>
            current != null && checkoutImages.some((item) => item.id === current)
                ? current
                : checkoutImages[0]?.id ?? null,
        );
    }, [checkoutImages]);

    useEffect(() => {
        if (!config.heroCountdownAt) {
            setHeroCountdownParts(null);
            return undefined;
        }

        const targetDate = parseCountdownTarget(config.heroCountdownAt);
        if (!targetDate) {
            setHeroCountdownParts(null);
            return undefined;
        }

        const updateCountdown = () => {
            setHeroCountdownParts(getCountdownParts(targetDate));
        };

        updateCountdown();
        const intervalId = window.setInterval(updateCountdown, 1000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [config.heroCountdownAt]);



    useEffect(() => {
        const container = carouselRef.current;
        if (!container) return undefined;

        const handleScroll = () => {
            if (!container.clientWidth) return;
            const nextIndex = Math.round(
                container.scrollLeft / container.clientWidth,
            );
            setActiveBannerIndex(Math.max(0, Math.min(nextIndex, bannerCount - 1)));
        };

        container.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();

        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [bannerCount]);

    useEffect(() => {
        const container = carouselRef.current;
        if (!container || bannerCount <= 1) return undefined;

        const intervalId = window.setInterval(() => {
            setActiveBannerIndex((currentIndex) => {
                const nextIndex = (currentIndex + 1) % bannerCount;
                container.scrollTo({
                    left: container.clientWidth * nextIndex,
                    behavior: "smooth",
                });
                return nextIndex;
            });
        }, 4000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [bannerCount]);

    const incrementOrderQuantity = () => {
        setOrderQuantity((current) => Math.min(current + 1, 99));
    };

    const decrementOrderQuantity = () => {
        setOrderQuantity((current) => Math.max(current - 1, 1));
    };

    const scrollToOrderForm = (behavior = "smooth") => {
        document
            .getElementById("order-form")
            ?.scrollIntoView({ behavior });
    };

    const handleBuyNowClick = (behavior = "smooth") => {
        fbTrack("InitiateCheckout", {
            content_ids: [String(config.id)],
            content_type: "product",
            content_name: config.checkoutProductName || config.headline,
            currency: "BDT",
            value: parsedOfferPrice,
        });
        scrollToOrderForm(behavior);
    };

    const normalizeBangladeshiPhone = (phone) => {
        const digits = String(phone).replace(/[^0-9]/g, "");
        return digits.startsWith("880") ? `0${digits.slice(3)}` : digits;
    };

    const isValidBangladeshiPhone = (phone) =>
        /^01\d{9}$/.test(normalizeBangladeshiPhone(phone));

    const validateOrderForm = () => {
        const errors = {};

        if (!customerName.trim()) {
            errors.customerName = "নাম আবশ্যক";
        }
        if (!customerPhone.trim()) {
            errors.customerPhone = "মোবাইল নাম্বার আবশ্যক";
        } else if (!isValidBangladeshiPhone(customerPhone)) {
            errors.customerPhone = "সঠিক বাংলাদেশী মোবাইল নাম্বার দিন (01XXXXXXXXX)";
        }
        if (!deliveryArea) {
            errors.deliveryArea = "ডেলিভারি এরিয়া নির্বাচন করুন";
        }
        if (!customerAddress.trim()) {
            errors.customerAddress = "সম্পূর্ণ ঠিকানা আবশ্যক";
        }
        if (!orderQuantity || orderQuantity < 1) {
            errors.orderQuantity = "পরিমাণ কমপক্ষে ১ হতে হবে";
        }
        if (checkoutColorOptions.length > 0 && !selectedColor) {
            errors.selectedColor = "রং নির্বাচন করুন";
        }

        setOrderFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const buildOrderPayload = () => ({
        landingPageId: config.id,
        name: customerName.trim(),
        phone: normalizeBangladeshiPhone(customerPhone),
        address: customerAddress.trim(),
        color: selectedColor || null,
        productImage: selectedCheckoutImage?.imagePath || null,
        deliveryArea,
        deliveryCharge: isFreeDelivery
            ? "Free Delivery"
            : deliveryArea === "outside"
                ? config.orderFormOutsideFeeLabel
                : config.orderFormInsideFeeLabel,
        quantity: orderQuantity,
        productName: config.orderFormProductName || config.checkoutProductName,
        unitPrice: parsedOfferPrice,
        subtotal: orderSubtotal,
        deliveryFee,
        total: orderTotal,
        ...getFbContext(),
    });

    const handleOrderSubmit = async () => {
        if (!validateOrderForm()) {
            scrollToOrderForm();
            return;
        }

        setIsSubmittingOrder(true);
        setOrderSubmitStatus(null);

        try {
            const payload = buildOrderPayload();
            const response = await fetch(apiUrl("/placeLandingOrder"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json().catch(() => null);

            if (!response.ok || !data?.success) {
                throw new Error(data?.message || "Order failed");
            }

            fbTrack(
                "Lead",
                {
                    content_ids: [String(config.id)],
                    content_type: "product",
                    content_name: config.orderFormProductName || config.checkoutProductName,
                    currency: "BDT",
                    value: orderTotal,
                },
                data?.data?.id ? `landing-order-${data.data.id}` : undefined,
            );

            setShowOrderConfirmModal(true);
            setCustomerName("");
            setCustomerPhone("");
            setCustomerAddress("");
            setDeliveryArea("inside");
            setOrderQuantity(1);
            setSelectedColor(checkoutColorOptions[0] || "");
            setSelectedImageId(checkoutImages[0]?.id ?? null);
            setOrderFormErrors({});
        } catch (error) {
            setOrderSubmitStatus({
                type: "error",
                message: error.message || "Something went wrong. Please try again.",
            });
            scrollToOrderForm();
        } finally {
            setIsSubmittingOrder(false);
        }
    };

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <main
            className="relative overflow-hidden select-none pb-[68px] md:pb-0"
            style={pageStyles}
        >
            <div className="absolute inset-0 -z-10">
                <div
                    className="absolute -left-24 top-[-5rem] h-72 w-72 rounded-full blur-3xl"
                    style={{ backgroundColor: config.accentSoftColor }}
                />
                <div
                    className="absolute right-[-4rem] top-16 h-80 w-80 rounded-full blur-3xl opacity-70"
                    style={{ backgroundColor: config.surfaceAltColor }}
                />
            </div>
            {/*Main Section*/}
            {(config.heroTag || config.headline || config.subheadline || config.imageUrl) ? (
                <section className="mx-auto flex w-full max-w-7xl flex-col md:gap-10 gap-4 px-4 pt-3 sm:py-6 sm:px-6 lg:flex-row lg:items-center lg:gap-14 lg:px-8 lg:py-20">
                    <div className="flex-1 justify-center md:justify-start space-y-6">
                        {config.heroTag ? (
                            <div className="flex justify-center md:justify-start">
                                <div
                                    className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium backdrop-blur"
                                    style={surfaceAltStyle}
                                >
                                    <Sparkles
                                        className="h-4 w-4"
                                        style={{ color: config.accentColor }}
                                    />
                                    <span>{config.heroTag}</span>
                                </div>
                            </div>
                        ) : null}

                        <div className="space-y-4 text-center">
                            <h1 className="max-w-2xl text-2xl font-black md:leading-loose leading-16 sm:text-5xl lg:text-5xl">
                                {config.headline}
                            </h1>
                            <p className="max-w-2xl text-base leading-7 sm:text-lg">
                                {config.subheadline}
                            </p>
                        </div>

                        <div className="hidden flex-col gap-4 lg:flex">
                            <div className="flex flex-col items-center gap-1 text-center">
                                {config.regularPriceAmount ? (
                                    <p
                                        className="text-sm font-medium line-through decoration-2 decoration-current decoration-offset-4 sm:text-base"
                                        style={{ color: config.mutedTextColor }}
                                    >
                                        {config.regularPriceLabel}{" "}
                                        {toBanglaDigits(config.regularPriceAmount)}
                                        {config.regularPriceCurrencySymbol}
                                    </p>
                                ) : null}

                                {config.offerPriceAmount ? (
                                    <p
                                        className="text-2xl font-black sm:text-4xl"
                                        style={{ color: config.accentColor }}
                                    >
                                        {config.offerPriceLabel} : {toBanglaDigits(config.offerPriceAmount)}
                                        {config.offerPriceCurrencySymbol}
                                    </p>
                                ) : null}

                                {heroSavingsAmount > 0 ? (
                                    <p className="text-sm font-semibold text-emerald-600 sm:text-base">
                                        সাশ্রয় {toBanglaDigits(heroSavingsAmount)}
                                        {config.offerPriceCurrencySymbol}
                                        {isFreeDelivery ? " + ফ্রি ডেলিভারি" : ""}
                                    </p>
                                ) : null}
                            </div>
                            {config.offerPriceAmount ? (
                                <div className="flex flex-col gap-3 sm:flex-row">
                                    <button
                                        type="button"
                                        onClick={() => handleBuyNowClick("auto")}
                                        className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-transform duration-200 hover:-translate-y-0.5"
                                        style={primaryButtonStyle}
                                    >
                                        {config.orderNowLabel}
                                        <ArrowRight className="h-4 w-4" />
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="flex-1">
                        {config.imageUrl ? (
                            <div className="relative overflow-hidden rounded-[2rem]  ">
                                <div
                                    className="absolute left-6 top-6 h-full w-24 rounded-full blur-2xl"
                                    style={{ backgroundColor: config.accentSoftColor }}
                                />
                                <div
                                    className="relative overflow-hidden rounded-[1.5rem]"
                                    style={surfaceAltStyle}
                                >
                                    <img
                                        src={heroImage}
                                        alt={config.headline}
                                        className="h-auto w-full"
                                    />
                                </div>
                            </div>
                        ) : null}

                        <div className="mt-4 flex flex-col gap-4 lg:hidden px-4 pb-2">
                            <div className="flex flex-col items-center gap-1 text-center">
                                {config.regularPriceAmount ? (
                                    <p
                                        className="text-sm font-medium line-through decoration-2 decoration-current decoration-offset-4"
                                        style={{ color: config.mutedTextColor }}
                                    >
                                        {config.regularPriceLabel}{" "}
                                        {toBanglaDigits(config.regularPriceAmount)}
                                        {config.regularPriceCurrencySymbol}
                                    </p>
                                ) : null}

                                {config.offerPriceAmount ? (
                                    <p
                                        className="text-2xl font-black sm:text-3xl"
                                        style={{ color: config.accentColor }}
                                    >
                                        {config.offerPriceLabel} : {toBanglaDigits(config.offerPriceAmount)}
                                        {config.offerPriceCurrencySymbol}
                                    </p>
                                ) : null}

                                {heroSavingsAmount > 0 ? (
                                    <p className="text-sm font-semibold text-emerald-600">
                                        সাশ্রয় {toBanglaDigits(heroSavingsAmount)}
                                        {config.offerPriceCurrencySymbol}
                                        {isFreeDelivery ? " + ফ্রি ডেলিভারি" : ""}
                                    </p>
                                ) : null}
                            </div>

                            <div className="flex flex-col gap-3 sm:flex-row">
                                <button
                                    type="button"
                                    onClick={() => handleBuyNowClick()}
                                    className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-transform duration-200 hover:-translate-y-0.5"
                                    style={primaryButtonStyle}
                                >
                                    {config.orderNowLabel}
                                    <ArrowRight className="h-4 w-4" />
                                </button>
                            </div>

                            {heroCountdownParts ? (
                                <div className="grid grid-cols-4 gap-3 pt-2">
                                    {[
                                        ["দিন", heroCountdownParts.days],
                                        ["ঘন্টা", heroCountdownParts.hours],
                                        ["মিনিট", heroCountdownParts.minutes],
                                        ["সেকেন্ড", heroCountdownParts.seconds],
                                    ].map(([label, value]) => (
                                        <div
                                            key={label}
                                            className="rounded-2xl border px-3 py-3 text-center backdrop-blur-sm"
                                            style={surfaceAltStyle}
                                        >
                                            <div
                                                className="text-2xl font-black leading-none"
                                                style={{ color: config.accentColor }}
                                            >
                                                {toBanglaDigits(value)}
                                            </div>
                                            <div
                                                className="mt-1 text-[10px] font-semibold "
                                                style={{ color: config.mutedTextColor }}
                                            >
                                                {label}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </section>
            ):null}
            {bannerCards.length > 0 ? (
                <section>
                    <div className="max-w-7xl mx-auto p-4 px-4 pb-5 sm:px-6 lg:px-8 lg:pb-20 rounded-2xl">
                        <Swiper
                            modules={[Autoplay, Navigation]}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            navigation={{
                                nextEl: ".custom-next",
                                prevEl: ".custom-prev",
                            }}
                            loop={true}
                            speed={800}
                            spaceBetween={0}
                            slidesPerView={1}
                            className="w-full h-[150px]  md:h-[270px] lg:h-[370px] rounded-2xl"
                        >
                            {bannerCards.map((item, index) => (
                                <SwiperSlide key={`${item.alt || item.src || index}`}>
                                    <div className="relative w-full h-full rounded-2xl">
                                        <img
                                            src={item.src || item.image || item.url }
                                            alt={item.alt || `Banner ${index + 1}`}
                                            className="w-full h-full object-fit rounded-2xl"
                                            draggable="false"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </section>
            ) : null}
            {/*Item Section*/}
            {(config.offerSectionBadge || heroCountdownParts || config.offerSectionItems.length > 0 )? (
                <section className="mx-auto w-full max-w-7xl pb-8  lg:pb-20">
                    <div
                        className=" p-4 sm:p-6 lg:p-8"
                        style={{
                            borderColor: itemSectionTheme.sectionBorder,
                            backgroundColor: itemSectionTheme.sectionBg,
                            boxShadow: itemSectionTheme.sectionShadow,
                        }}
                    >
                        <div className="mx-auto sm:mb-8 mb-4 max-w-3xl text-center">
                            {config.offerSectionBadge ? (
                                <div
                                    className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold"
                                    style={{
                                        backgroundColor: itemSectionTheme.badgeBg,
                                        color: itemSectionTheme.badgeText,
                                    }}
                                >
                                    <Sparkles className="h-4 w-4" />
                                    <span>{config.offerSectionBadge}</span>
                                </div>
                            ):null}
                            <h2
                                className="mt-4 text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl"
                                style={{ color: itemSectionTheme.headingText }}
                            >
                                {config.offerSectionTitle}
                            </h2>
                            <p
                                className="mx-auto mt-3 max-w-2xl text-sm leading-7 sm:text-base"
                                style={{ color: itemSectionTheme.bodyText }}
                            >
                                {config.offerSectionSubtitle}
                            </p>
                        </div>

                        <div className="">
                            <div
                                className="flex flex-col gap-4"
                                style={{
                                    backgroundColor: itemSectionTheme.sectionBg,
                                }}
                            >
                                {config.offerSectionItems.length > 0 ? (
                                    <div
                                        className="overflow-hidden rounded-[1.5rem] border"
                                        style={{
                                            borderColor: itemSectionTheme.listBorder,
                                            backgroundColor: itemSectionTheme.listBg,
                                        }}
                                    >
                                        {config.offerSectionItems.map((item, index) => (
                                            <div
                                                key={`${item.label}-${index}`}
                                                className={`flex items-center justify-between gap-4 px-4 py-4 sm:px-5 ${
                                                    index !== config.offerSectionItems.length - 1 ? "" : ""
                                                }`}
                                                style={{
                                                    borderBottom:
                                                        index !== config.offerSectionItems.length - 1
                                                            ? `1px solid ${itemSectionTheme.rowBorder}`
                                                            : "none",
                                                }}
                                            >
                                                <div className="flex items-center gap-3">
                      <span
                          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold"
                          style={{
                              backgroundColor: itemSectionTheme.stepBg,
                              color: itemSectionTheme.stepText,
                          }}
                      >
                        {index + 1}
                      </span>
                                                    <span
                                                        className="text-sm font-medium sm:text-base"
                                                        style={{ color: itemSectionTheme.itemText }}
                                                    >
                        {item.label}
                      </span>
                                                </div>
                                                <span
                                                    className="text-sm font-semibold sm:text-base"
                                                    style={{ color: itemSectionTheme.valueText }}
                                                >
                      {item.value}
                    </span>
                                            </div>
                                        ))}

                                        {config.checkoutBottomRowsText || config.checkoutButtonText ? (
                                            <div
                                                className="flex items-center justify-between gap-4 px-4 py-4 sm:px-5"
                                                style={{ backgroundColor: itemSectionTheme.totalBg }}
                                            >
                                                <div>
                                                    <p
                                                        className="text-xs font-semibold uppercase "
                                                        style={{ color: itemSectionTheme.totalText }}
                                                    >
                                                        {config.checkoutBottomRowsText}
                                                    </p>
                                                </div>
                                                <span
                                                    className="text-xl font-black sm:text-2xl"
                                                    style={{ color: itemSectionTheme.totalValueText }}
                                                >
                    {config.checkoutButtonText}
                  </span>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                                {/*{config.offerPriceAmount ? (*/}
                                {/*<div*/}
                                {/*  className="rounded-[1.5rem] p-5 shadow-xl"*/}
                                {/*  style={{*/}
                                {/*    backgroundColor: itemSectionTheme.summaryBg,*/}
                                {/*    color: itemSectionTheme.summaryText,*/}
                                {/*  }}*/}
                                {/*>*/}
                                {/*  <div*/}
                                {/*    className="flex items-center justify-between gap-4 border-b pb-4"*/}
                                {/*    style={{ borderBottomColor: itemSectionTheme.summaryDivider }}*/}
                                {/*  >*/}
                                {/*    {config.regularPriceAmount ? (*/}
                                {/*    <div>*/}
                                {/*      <p*/}
                                {/*        className="text-xs font-semibold uppercase tracking-[0.28em]"*/}
                                {/*        style={{*/}
                                {/*          color: itemSectionTheme.summaryMutedText,*/}
                                {/*          opacity: 0.85,*/}
                                {/*        }}*/}
                                {/*      >*/}
                                {/*        {config.regularPriceLabel}*/}
                                {/*      </p>*/}
                                {/*      <p*/}
                                {/*        className="mt-1 text-2xl font-semibold sm:text-3xl"*/}
                                {/*        style={{*/}
                                {/*          color: itemSectionTheme.summaryText,*/}
                                {/*          opacity: 0.92,*/}
                                {/*        }}*/}
                                {/*      >*/}
                                {/*        <span className="mr-1">*/}
                                {/*          {config.regularPriceCurrencySymbol}*/}
                                {/*        </span>*/}
                                {/*        <span className="line-through decoration-2 decoration-white/80 decoration-offset-4">*/}
                                {/*          {toBanglaDigits(config.regularPriceAmount)}*/}
                                {/*        </span>*/}
                                {/*      </p>*/}
                                {/*    </div>*/}
                                {/*    ) : null}*/}
                                {/*    {config.offerPriceAmount ? (*/}
                                {/*    <div className="text-right">*/}
                                {/*      <p*/}
                                {/*        className="text-xs font-semibold uppercase tracking-[0.28em]"*/}
                                {/*        style={{ color: itemSectionTheme.summaryAccent }}*/}
                                {/*      >*/}
                                {/*        {config.offerPriceLabel}*/}
                                {/*      </p>*/}
                                {/*      <p*/}
                                {/*        className="mt-1 text-3xl font-black sm:text-4xl"*/}
                                {/*        style={{ color: itemSectionTheme.summaryAccent }}*/}
                                {/*      >*/}
                                {/*        <span className="mr-1">*/}
                                {/*          {config.offerPriceCurrencySymbol}*/}
                                {/*        </span>*/}
                                {/*        <span>{toBanglaDigits(config.offerPriceAmount)}</span>*/}
                                {/*      </p>*/}
                                {/*    </div>*/}
                                {/*    ) : null}*/}

                                {/*  </div>*/}

                                {/*  <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">*/}
                                {/*    {heroCountdownParts ? (*/}
                                {/*    <div className="space-y-2">*/}
                                {/*      <p*/}
                                {/*        className="text-sm font-semibold uppercase tracking-[0.24em]"*/}
                                {/*        style={{*/}
                                {/*          color: itemSectionTheme.summaryMutedText,*/}
                                {/*          opacity: 0.8,*/}
                                {/*        }}*/}
                                {/*      >*/}
                                {/*        {config.offerSectionCountdownTitle}*/}
                                {/*      </p>*/}
                                {/*      {heroCountdownParts ? (*/}
                                {/*        <div className="grid grid-cols-4 gap-3 pt-2">*/}
                                {/*          {[*/}
                                {/*            ["Days", heroCountdownParts.days],*/}
                                {/*            ["Hours", heroCountdownParts.hours],*/}
                                {/*            ["Mins", heroCountdownParts.minutes],*/}
                                {/*            ["Secs", heroCountdownParts.seconds],*/}
                                {/*          ].map(([label, value]) => (*/}
                                {/*            <div*/}
                                {/*              key={label}*/}
                                {/*              className="rounded-2xl border px-3 py-3 text-center backdrop-blur-sm"*/}
                                {/*              style={surfaceAltStyle}*/}
                                {/*            >*/}
                                {/*              <div*/}
                                {/*                className="text-2xl font-black leading-none"*/}
                                {/*                style={{ color: config.accentColor }}*/}
                                {/*              >*/}
                                {/*                {value}*/}
                                {/*              </div>*/}
                                {/*              <div*/}
                                {/*                className="mt-1 text-[10px] font-semibold uppercase tracking-[0.24em]"*/}
                                {/*                style={{ color: config.mutedTextColor }}*/}
                                {/*              >*/}
                                {/*                {label}*/}
                                {/*              </div>*/}
                                {/*            </div>*/}
                                {/*          ))}*/}
                                {/*        </div>*/}
                                {/*      ) : null}*/}
                                {/*      /!* </div> *!/*/}
                                {/*    </div>*/}
                                {/*    ) : null}*/}

                                {/*    <ActionLink*/}
                                {/*      href={config.offerSectionCtaHref}*/}
                                {/*      className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:-translate-y-0.5"*/}
                                {/*      style={{*/}
                                {/*        backgroundImage: `linear-gradient(135deg, ${itemSectionTheme.ctaFrom}, ${itemSectionTheme.ctaTo})`,*/}
                                {/*        boxShadow: `0 16px 32px ${hexToRgba(itemSectionTheme.ctaTo, 0.28)}`,*/}
                                {/*      }}*/}
                                {/*    >*/}
                                {/*      {config.offerSectionCtaLabel}*/}
                                {/*      <ArrowRight className="h-4 w-4" />*/}
                                {/*    </ActionLink>*/}
                                {/*  </div>*/}
                                {/*</div>*/}
                                {/*) : null}*/}
                            </div>
                            {config.offerSectionFeatures.length > 0 ? (
                                <div className=" relative overflow-hidden">
                                    <div className="relative">
                                        <div className="mt-5 grid gap-3 sm:grid-cols-4 grid-cols-2">
                                            {config.offerSectionFeatures.map((feature) => {
                                                const Icon = feature.icon ;

                                                return (
                                                    <div
                                                        key={feature.title}
                                                        className="flex flex-col items-center text-center rounded-2xl border p-4 backdrop-blur-sm"
                                                        style={{
                                                            borderColor: hexToRgba(
                                                                itemSectionTheme.summaryBg,
                                                                0.12,
                                                            ),
                                                            backgroundColor: hexToRgba(
                                                                itemSectionTheme.totalBg,
                                                                0.04,
                                                            ),
                                                        }}
                                                    >
                                                        <div
                                                            className="mb-3 inline-flex sm:h-11 h-8 sm:w-11 w-8 items-center justify-center rounded-full"
                                                            style={{
                                                                backgroundColor: itemSectionTheme.summaryBg,
                                                            }}
                                                        >
                                                            <Icon
                                                                className="sm:h-5 h-4 sm:w-5 w-4"
                                                                style={{ color: itemSectionTheme.summaryText }}
                                                            />
                                                        </div>

                                                        <h3
                                                            className="sm:text-base text-xs font-semibold"
                                                            style={{ color: itemSectionTheme.summaryBg }}
                                                        >
                                                            {feature.title}
                                                        </h3>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </section>
            ):null}
            {/*Youtube section*/}
            {(config.mediaSectionVideoUrl || videoFeatureCards.length > 0)? (
                <section className="mx-auto w-full max-w-7xl px-4 pb-8 sm:px-6 lg:px-8 lg:pb-20">
                    <div className="sm:p-6 lg:p-8">
                        {config.mediaSectionVideoUrl ? (
                            <div className="mx-auto max-w-3xl text-center">
                                <div className="inline-flex items-center gap-2 rounded-full bg-amber-100 px-4 py-2 text-sm font-semibold text-amber-900 shadow-sm">
                                    <Sparkles className="h-4 w-4" />
                                    <span>{config.mediaSectionBadge}</span>
                                </div>
                            </div>
                        ): null}
                        {config.mediaSectionVideoUrl ? (
                            <div className="md:mt-8 mt-4 overflow-hidden rounded-[2rem]  bg-slate-950 shadow-2xl">
                                <div className="relative min-h-[320px] sm:min-h-[420px] lg:min-h-[480px]">
                                    {isVideoPlaying && youtubeEmbedUrl ? (
                                        <iframe
                                            src={youtubeEmbedUrl}
                                            title={config.mediaSectionTitle}
                                            className="absolute inset-0 h-full w-full"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        />
                                    ) : (
                                        <>
                                            <img
                                                src={mediaImage}
                                                alt={config.mediaSectionTitle}
                                                className="absolute inset-0 h-full w-full object-cover"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/35 to-black/20" />
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <button
                                                    type="button"
                                                    onClick={() => setIsVideoPlaying(true)}
                                                    aria-label={config.mediaSectionVideoLabel || "Play video"}
                                                    className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-lg backdrop-blur-sm transition hover:scale-105"
                                                >
                                                    <Youtube className="h-9 w-9 text-red-600" />
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        ): null}
                        {videoFeatureCards.length > 0 ? (
                            <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
                                {videoFeatureCards.map((item) => {
                                    const Icon = resolveLucideIcon(item.iconName);

                                    return (
                                        <div
                                            key={`${item.id || item.title}`}
                                            className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm text-center"
                                        >
                                            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[var(--nf-brand-100)] text-[var(--nf-brand-950)]">
                                                <Icon className="h-5 w-5" />
                                            </div>
                                            <h3 className="text-base font-bold text-slate-950">
                                                {item.title}
                                            </h3>
                                            <p className="mt-2 text-sm leading-6 text-slate-600">
                                                {item.subtitle}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : null}
                    </div>
                </section>
            ):null}
            {/*Bullet Points Section*/}
            {(bulletPoints.length > 0 || bulletMainImage) ? (
                <section className="mx-auto w-full max-w-7xl px-4 pb-6 sm:px-6 lg:px-8 lg:pb-20">
                    <div className="rounded-[2rem] border border-[var(--nf-brand-200)] bg-white p-4 shadow-[0_24px_70px_rgba(15,23,42,0.08)] sm:p-6 lg:p-8">
                        <div className="mx-auto max-w-3xl text-center">
                            {config.bulletCaption ? (
                                <div className="inline-flex items-center gap-2 rounded-full bg-[var(--nf-brand-100)] px-4 py-2 text-sm font-semibold text-[var(--nf-brand-950)] shadow-sm">
                                    <Sparkles className="h-4 w-4" />
                                    <span>{config.bulletCaption}</span>
                                </div>
                            ) : null}
                            <h2 className="mt-4 text-3xl font-black tracking-tight text-[var(--nf-brand-950)] sm:text-4xl lg:text-5xl">
                                {config.bulletTitle}
                            </h2>
                            <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-[var(--nf-brand-700)] sm:text-base">
                                {config.bulletSubtitle}
                            </p>
                        </div>

                        <div className="mt-8 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
                            <div className="space-y-3">
                                {bulletPoints.length > 0 ? (
                                    bulletPoints.map((item, index) => (
                                        <div
                                            key={`${item.id || index}`}
                                            className="flex items-center gap-3 rounded-2xl border border-[var(--nf-brand-200)] bg-[var(--nf-brand-50)] px-4 py-4"
                                        >
                    <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--nf-brand-100)] text-sm font-bold text-[var(--nf-brand-950)]">
                      {index + 1}
                    </span>
                                            <p className="text-sm font-medium text-[var(--nf-brand-900)] sm:text-base">
                                                {item.pointText || `Point ${index + 1}`}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <div></div>
                                )}
                            </div>

                            {bulletMainImage ? (
                                <div className="relative overflow-hidden rounded-[2rem] md:border md:border-[var(--nf-brand-200)] md:bg-[var(--nf-brand-50)] md:p-3">
                                    <img
                                        src={bulletMainImage}
                                        alt={config.bulletTitle}
                                        className="h-full w-full rounded-[1.5rem] object-cover"
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </section>
            ) : null}
            {/*Combo Images Section*/}
            {comboImages.length > 0 ? (
                <section className="mx-auto w-full max-w-7xl px-4 pb-6 sm:px-6 lg:px-8 lg:pb-20">
                    <div className="rounded-[2rem] border border-[var(--nf-brand-200)] bg-white p-4 shadow-[0_24px_70px_rgba(15,23,42,0.08)] sm:p-6 lg:p-8">
                        <div className="mx-auto max-w-3xl text-center">
                            <div className="inline-flex items-center gap-2 rounded-full bg-[var(--nf-brand-100)] px-4 py-2 text-sm font-black text-[var(--nf-brand-950)] shadow-sm">
                                <Package className="h-4 w-4" />
                                <span>প্যাকেজে কী কী আছে?</span>
                            </div>
                            <p className="mx-auto mt-3 text-sm leading-7 text-[var(--nf-brand-700)] sm:text-base font-black">
                                👆 ছবিতে ক্লিক করে বড় করে দেখুন
                            </p>
                        </div>

                        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
                            {comboImages.map((item) => (
                                <button
                                    key={item.id}
                                    type="button"
                                    onClick={() => setComboZoomImage(item)}
                                    className="group overflow-hidden rounded-2xl border border-[var(--nf-brand-200)] bg-white text-left shadow-sm transition hover:shadow-md"
                                >
                                    <div className="aspect-square w-full overflow-hidden bg-[var(--nf-brand-50)]">
                                        {item.src ? (
                                            <img
                                                src={item.src}
                                                alt={item.title || "Combo item"}
                                                className="h-full w-full object-cover transition duration-200 group-hover:scale-105"
                                            />
                                        ) : null}
                                    </div>
                                    {item.title || item.shortNote ? (
                                        <div className="bg-red-700 px-2 py-2 text-center">
                                            {item.title ? (
                                                <p className="text-xs font-black text-white sm:text-sm">
                                                    {item.title}
                                                </p>
                                            ) : null}
                                            {item.shortNote ? (
                                                <p className="mt-0.5 text-[11px] font-bold text-white/90 sm:text-xs">
                                                    {item.shortNote}
                                                </p>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </button>
                            ))}
                        </div>
                    </div>
                </section>
            ) : null}
            {/*Secret Tip Section*/}
            {config.secretTipTitle && config.secretTipDescription ? (
                <section className="mx-auto w-full max-w-7xl px-4 pb-6 sm:px-6 lg:px-8 lg:pb-20">
                    <div className="flex items-start gap-4 rounded-[1.75rem] border border-[var(--nf-brand-200)] bg-[var(--nf-brand-50)] p-5 sm:p-6">
          <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-[var(--nf-brand-600)] shadow-sm">
            <SecretTipIcon className="h-5 w-5" />
          </span>
                        <div className="space-y-2">
                            <h3 className="text-base font-bold text-[var(--nf-brand-950)] sm:text-lg">
                                {config.secretTipTitle}
                            </h3>
                            <p className="text-sm leading-7 text-[var(--nf-brand-900)] sm:text-base">
                                {config.secretTipDescription}
                            </p>
                        </div>
                    </div>
                </section>
            ) : null}
            {/*Order Form*/}
            <section
                id="order-form"
                className="py-5 sm:py-16 lg:py-20"
                style={{ backgroundColor: orderFormTheme.sectionBg }}
            >
                <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div
                        className=" text-center"
                        style={{ color: orderFormTheme.sectionText }}
                    >
                        <div
                            className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold shadow-lg"
                            style={{
                                backgroundColor: orderFormTheme.badgeBg,
                                color: orderFormTheme.badgeText,
                                boxShadow: `0 16px 34px ${hexToRgba(orderFormTheme.badgeBg, 0.22)}`,
                            }}
                        >
                            <BadgeCheck className="h-4 w-4" />
                            <span>{config.checkoutCaption || config.orderFormBadge}</span>
                        </div>
                        <h2
                            className="mt-4 text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl"
                            style={{ color: orderFormTheme.sectionText }}
                        >
                            {config.checkoutTitle || config.orderFormTitle}
                        </h2>
                        <p
                            className="mx-auto mt-3 max-w-2xl text-sm leading-7 sm:text-base"
                            style={{ color: orderFormTheme.sectionText, opacity: 0.72 }}
                        >
                            {config.checkoutSubtitle || config.orderFormSubtitle}
                        </p>
                    </div>

                    <div
                        className="mx-auto md:mt-10 mt-5 max-w-5xl overflow-hidden rounded-[1rem] lg:rounded-[2.25rem] bg-white"
                        style={{
                            boxShadow: orderFormTheme.cardShadow,
                        }}
                    >
                        <div>
                            <div className="p-5 sm:p-6 lg:p-8">
                                <div className="">
                                    {checkoutImages.length > 0 ? (
                                        <div
                                            className="mb-4 flex flex-col gap-4 rounded-[1.25rem] border p-4"
                                            style={{ borderColor: orderFormTheme.panelBorder }}
                                        >
                                            <div className="flex flex-col gap-4 sm:flex-row">
                                                <div
                                                    className="h-48 w-full shrink-0 overflow-hidden rounded-2xl border bg-[var(--nf-brand-50)] sm:h-32 sm:w-32"
                                                    style={{ borderColor: orderFormTheme.panelBorder }}
                                                >
                                                    <img
                                                        src={selectedCheckoutImage?.src || checkoutProductImage}
                                                        alt={selectedCheckoutImage?.color || config.checkoutProductName}
                                                        className="h-full w-full object-cover"
                                                    />
                                                </div>
                                                <div className="flex-1">
                                                    {checkoutColorOptions.length > 0 ? (
                                                        <>
                              <span
                                  className="mb-2 block text-sm font-semibold"
                                  style={{ color: orderFormTheme.headingText }}
                              >
                                রং নির্বাচন করুন
                              </span>
                                                            <div className="flex flex-wrap gap-2">
                                                                {checkoutColorOptions.map((color) => {
                                                                    const selected =
                                                                        selectedColor.toLowerCase() ===
                                                                        color.toLowerCase();
                                                                    const colorNames = splitColorNames(color);
                                                                    return (
                                                                        <button
                                                                            key={color}
                                                                            type="button"
                                                                            onClick={() => selectCheckoutColor(color)}
                                                                            className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-semibold transition"
                                                                            style={{
                                                                                borderColor: selected
                                                                                    ? orderFormTheme.optionSelectedBorder
                                                                                    : orderFormTheme.optionDefaultBorder,
                                                                                backgroundColor: selected
                                                                                    ? orderFormTheme.optionSelectedBg
                                                                                    : orderFormTheme.panelBg,
                                                                                color: selected
                                                                                    ? orderFormTheme.headingText
                                                                                    : orderFormTheme.optionDefaultText,
                                                                            }}
                                                                        >
                                      <span
                                          className="h-4 w-4 shrink-0 rounded-full border"
                                          style={{
                                              background:
                                                  getSwatchBackground(colorNames),
                                              borderColor:
                                              orderFormTheme.inputBorder,
                                          }}
                                      />
                                                                            {color}
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                            {orderFormErrors.selectedColor ? (
                                                                <p className="mt-1 text-xs text-red-600">
                                                                    {orderFormErrors.selectedColor}
                                                                </p>
                                                            ) : null}
                                                        </>
                                                    ) : null}
                                                </div>
                                            </div>

                                            {checkoutImages.length > 1 ? (
                                                <div className="flex flex-wrap gap-3">
                                                    {checkoutImages.map((item, index) => {
                                                        const isSelected =
                                                            selectedCheckoutImage?.id === item.id;
                                                        return (
                                                            <button
                                                                key={item.id}
                                                                type="button"
                                                                onClick={() => selectCheckoutImage(item)}
                                                                aria-label={item.color || `Product image ${index + 1}`}
                                                                className="h-16 w-16 shrink-0 overflow-hidden rounded-xl border-2 transition"
                                                                style={{
                                                                    borderColor: isSelected
                                                                        ? orderFormTheme.optionSelectedBorder
                                                                        : orderFormTheme.optionDefaultBorder,
                                                                }}
                                                            >
                                                                <img
                                                                    src={item.src}
                                                                    alt={item.color || `Product image ${index + 1}`}
                                                                    className="h-full w-full object-cover"
                                                                />
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                    {/* <div
                    className="flex flex-col gap-3 rounded-[1.25rem] border p-4 sm:flex-row sm:items-center sm:justify-between"
                    style={{
                      borderColor: orderFormTheme.panelBorder,
                    }}
                  >
                    <div className="flex items-center gap-4">
                      <div className="md:h-20 md:w-24 h-12 w-12 overflow-hidden rounded-2xl border border-[var(--nf-brand-200)] bg-[var(--nf-brand-50)]">
                        <img
                          src={checkoutProductImage}
                          alt={
                            config.checkoutProductName ||
                            config.orderFormProductName
                          }
                          className="h-full w-full object-cover"
                        />
                      </div>
                      <div>
                        <h3
                          className="mt-1 text-sm font-black sm:text-2xl"
                          style={{ color: orderFormTheme.headingText }}
                        >
                          {config.checkoutProductName ||
                            config.orderFormProductName}
                        </h3>
                        <p
                          className="mt-1 md:text-sm text-xs"
                          style={{ color: orderFormTheme.bodyText }}
                        >
                          {config.checkoutProductSubname ||
                            config.orderFormProductDescription}
                        </p>
                      </div>
                    </div>
                    <div className="text-left sm:text-right">
                      <p
                        className="mt-1 md:text-3xl font-black"
                        style={{ color: orderFormTheme.priceAccent }}
                      >
                        <span className="mr-1">
                          {config.offerPriceCurrencySymbol}
                        </span>
                        <span>
                          {toBanglaDigits(config.checkoutPrice || config.offerPriceAmount)}
                        </span>
                      </p>
                    </div>
                  </div> */}

                                    <div className="md:m2t-5 mt- grid gap-4 sm:grid-cols-2">
                                        <label className="block">
                      <span
                          className="mb-2 block text-sm font-semibold"
                          style={{ color: orderFormTheme.headingText }}
                      >
                        {config.orderFormNameLabel}
                      </span>
                                            <input
                                                type="text"
                                                value={customerName}
                                                onChange={(event) =>
                                                    setCustomerName(event.target.value)
                                                }
                                                placeholder={config.orderFormNamePlaceholder}
                                                className="w-full rounded-2xl border bg-white px-4 py-3 text-sm outline-none transition placeholder:opacity-40"
                                                style={{
                                                    borderColor: orderFormErrors.customerName
                                                        ? "#dc2626"
                                                        : orderFormTheme.inputBorder,
                                                    color: orderFormTheme.inputText,
                                                }}
                                            />
                                            {orderFormErrors.customerName ? (
                                                <p className="mt-1 text-xs text-red-600">
                                                    {orderFormErrors.customerName}
                                                </p>
                                            ) : null}
                                        </label>

                                        <label className="block">
                      <span
                          className="mb-2 block text-sm font-semibold"
                          style={{ color: orderFormTheme.headingText }}
                      >
                        {config.orderFormPhoneLabel}
                      </span>
                                            <input
                                                type="tel"
                                                value={customerPhone}
                                                onChange={(event) =>
                                                    setCustomerPhone(event.target.value)
                                                }
                                                placeholder={config.orderFormPhonePlaceholder}
                                                className="w-full rounded-2xl border bg-white px-4 py-3 text-sm outline-none transition placeholder:opacity-40"
                                                style={{
                                                    borderColor: orderFormErrors.customerPhone
                                                        ? "#dc2626"
                                                        : orderFormTheme.inputBorder,
                                                    color: orderFormTheme.inputText,
                                                }}
                                            />
                                            {orderFormErrors.customerPhone ? (
                                                <p className="mt-1 text-xs text-red-600">
                                                    {orderFormErrors.customerPhone}
                                                </p>
                                            ) : null}
                                        </label>
                                    </div>

                                    <div className="mt-4 grid gap-4 lg:grid-cols-[0.95fr_1.05fr]">
                                        <div className="block">
                      <span
                          className="mb-2 block text-sm font-semibold"
                          style={{ color: orderFormTheme.headingText }}
                      >
                        {config.orderFormQuantityLabel}
                      </span>
                                            <div
                                                className="inline-flex items-center gap-3 rounded-2xl border bg-white p-2 shadow-sm"
                                                style={{ borderColor: orderFormTheme.inputBorder }}
                                            >
                                                <button
                                                    type="button"
                                                    onClick={decrementOrderQuantity}
                                                    className="flex h-10 w-10 items-center justify-center rounded-full border text-lg font-bold transition hover:bg-[var(--nf-brand-100)]"
                                                    style={{
                                                        borderColor: orderFormTheme.inputBorder,
                                                        color: orderFormTheme.bodyText,
                                                    }}
                                                    aria-label="Decrease quantity"
                                                >
                                                    -
                                                </button>
                                                <div
                                                    className="min-w-[3rem] text-center text-lg font-black"
                                                    style={{ color: orderFormTheme.headingText }}
                                                >
                                                    {orderQuantity}
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={incrementOrderQuantity}
                                                    className="flex h-10 w-10 items-center justify-center rounded-full border text-lg font-bold transition hover:bg-[var(--nf-brand-100)]"
                                                    style={{
                                                        borderColor: orderFormTheme.inputBorder,
                                                        color: orderFormTheme.bodyText,
                                                    }}
                                                    aria-label="Increase quantity"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>

                                        <div className="block">
                      <span
                          className="mb-2 block text-sm font-semibold"
                          style={{ color: orderFormTheme.headingText }}
                      >
                        {config.checkoutDeliveryOptionsText ||
                            config.orderFormDeliveryLabel}
                      </span>
                                            <div className="grid gap-3 grid-cols-2">
                                                {[
                                                    {
                                                        value: "inside",
                                                        label: config.orderFormInsideLabel,
                                                    },
                                                    {
                                                        value: "outside",
                                                        label: config.orderFormOutsideLabel,
                                                    },
                                                ].map((option) => {
                                                    const selected = deliveryArea === option.value;
                                                    return (
                                                        <button
                                                            key={option.value}
                                                            type="button"
                                                            onClick={() => setDeliveryArea(option.value)}
                                                            className={`rounded-2xl border px-4 py-3 text-left text-sm font-semibold transition ${
                                                                selected ? "" : "hover:bg-[var(--nf-brand-50)]"
                                                            }`}
                                                            style={{
                                                                borderColor: selected
                                                                    ? orderFormTheme.optionSelectedBorder
                                                                    : orderFormTheme.optionDefaultBorder,
                                                                backgroundColor: selected
                                                                    ? orderFormTheme.optionSelectedBg
                                                                    : orderFormTheme.panelBg,
                                                                color: selected
                                                                    ? orderFormTheme.headingText
                                                                    : orderFormTheme.optionDefaultText,
                                                            }}
                                                        >
                              <span className="flex items-center gap-2">
                                <span
                                    className="inline-flex h-3.5 w-3.5 rounded-full border"
                                    style={{
                                        borderColor: selected
                                            ? orderFormTheme.optionSelectedDot
                                            : orderFormTheme.optionDefaultDot,
                                        backgroundColor: selected
                                            ? orderFormTheme.optionSelectedDot
                                            : orderFormTheme.panelBg,
                                    }}
                                />
                                <span>{option.label}</span>
                              </span>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <label className="block">
                      <span
                          className="mb-2 block text-sm font-semibold"
                          style={{ color: orderFormTheme.headingText }}
                      >
                        {config.orderFormAddressLabel}
                      </span>
                                            <textarea
                                                rows={4}
                                                value={customerAddress}
                                                onChange={(event) =>
                                                    setCustomerAddress(event.target.value)
                                                }
                                                placeholder={config.orderFormAddressPlaceholder}
                                                className="w-full rounded-2xl border bg-white px-4 py-3 text-sm outline-none transition placeholder:opacity-40"
                                                style={{
                                                    borderColor: orderFormErrors.customerAddress
                                                        ? "#dc2626"
                                                        : orderFormTheme.inputBorder,
                                                    color: orderFormTheme.inputText,
                                                }}
                                            />
                                            {orderFormErrors.customerAddress ? (
                                                <p className="mt-1 text-xs text-red-600">
                                                    {orderFormErrors.customerAddress}
                                                </p>
                                            ) : null}
                                        </label>
                                    </div>

                                    <div className="mt-4 grid gap-4 sm:grid-cols-[1fr_auto]">
                                        <div
                                            className="rounded-2xl border border-dashed px-4 py-3 text-sm"
                                            style={{
                                                borderColor: orderFormTheme.couponBorder,
                                                backgroundColor: orderFormTheme.couponBg,
                                                color: orderFormTheme.couponText,
                                            }}
                                        >
                                            {config.checkoutDeliveryOptionsText ||
                                                config.orderFormCouponLabel}
                                        </div>
                                    </div>

                                    {/* <div
                    className="mt-4 rounded-[1.5rem] px-4 py-4"
                    style={{
                      backgroundColor: orderFormTheme.summaryBg,
                      color: orderFormTheme.summaryText,
                    }}
                  >
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <p
                          className="text-xs font-semibold uppercase tracking-[0.24em]"
                          style={{
                            color: orderFormTheme.summaryMutedText,
                            opacity: 0.85,
                          }}
                        >
                          {config.orderFormInsideFeeLabel}
                        </p>
                        <p
                          className="mt-1 text-sm"
                          style={{
                            color: orderFormTheme.summaryMutedText,
                            opacity: 0.9,
                          }}
                        >
                          {config.orderFormSupportLabel}
                        </p>
                      </div>
                      <div className="text-left sm:text-right">
                        <p
                          className="text-sm"
                          style={{
                            color: orderFormTheme.summaryMutedText,
                            opacity: 0.75,
                          }}
                        >
                          Delivery fee
                        </p>
                        <p className="text-2xl font-black">
                          {config.offerPriceCurrencySymbol}{" "}
                          {formatPrice(deliveryFee)}
                        </p>
                      </div>
                    </div>

                    <div
                      className="mt-4 border-t pt-4"
                      style={{ borderTopColor: orderFormTheme.summaryDivider }}
                    >
                      <div className="flex items-end justify-between gap-4">
                        <div>
                          <p
                            className="text-sm font-semibold uppercase tracking-[0.24em]"
                            style={{
                              color: orderFormTheme.summaryMutedText,
                              opacity: 0.8,
                            }}
                          >
                            Order total
                          </p>
                          <p
                            className="mt-1 text-xs"
                            style={{
                              color: orderFormTheme.summaryMutedText,
                              opacity: 0.7,
                            }}
                          >
                            {config.checkoutBottomRowsText ||
                              config.orderFormNote}
                          </p>
                        </div>
                        <div className="text-right">
                          <p
                            className="text-sm"
                            style={{
                              color: orderFormTheme.summaryMutedText,
                              opacity: 0.75,
                            }}
                          >
                            {formatPrice(orderSubtotal)} +{" "}
                            {formatPrice(deliveryFee)}
                          </p>
                          <p
                            className="text-3xl font-black"
                            style={{ color: orderFormTheme.summaryAccent }}
                          >
                            {config.offerPriceCurrencySymbol}{" "}
                            {formatPrice(orderTotal)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> */}

                                    <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ">
                                        {/* <p
                      className="text-sm"
                      style={{ color: orderFormTheme.bodyText }}
                    >
                      {config.checkoutBottomRowsText || config.orderFormNote}
                    </p> */}
                                        <div>
                                            <p
                                                className="text-xs font-medium uppercase "
                                                style={{ color: orderFormTheme.bodyText }}
                                            >
                                                {config.offerPriceLabel}
                                            </p>
                                            <p
                                                className="text-2xl font-black"
                                            >
                                                {config.offerPriceCurrencySymbol}{" "}
                                                {formatPrice(orderTotal)}
                                            </p>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleOrderSubmit}
                                            disabled={isSubmittingOrder}
                                            className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-70"
                                            style={{
                                                backgroundImage: `linear-gradient(135deg, ${orderFormTheme.ctaFrom}, ${orderFormTheme.ctaTo})`,
                                                boxShadow: `0 16px 32px ${hexToRgba(orderFormTheme.ctaTo, 0.28)}`,
                                            }}
                                        >
                                            {isSubmittingOrder ? "..." : config.orderNowLabel}
                                            <ArrowRight className="h-4 w-4" />
                                        </button>
                                    </div>
                                    {orderSubmitStatus ? (
                                        <p className="mt-3 text-sm font-medium text-red-600">
                                            {orderSubmitStatus.message}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*FAQ Section*/}
            {faqCards.length > 0 ? (
                <section className="bg-[var(--nf-brand-50)] mx-auto w-full max-w-7xl px-4 pb-2 sm:px-6 lg:px-8 lg:pb-20">
                    <div className="py-5">
                        <div className="mx-auto max-w-3xl text-center">
                            <div className="inline-flex items-center rounded-full bg-[var(--nf-brand-100)] px-4 py-2 text-sm font-semibold text-[var(--nf-brand-950)] shadow-sm">
                                {config.faqCaption || t("faqBadge", language)}
                            </div>
                            <h2 className="sm:mt-4 mt-2 text-2xl font-black tracking-tight text-[var(--nf-brand-950)] sm:text-4xl lg:text-5xl">
                                {config.faqTitle || t("faqTitle", language)}
                            </h2>
                        </div>

                        <div
                            className="mx-auto md:mt-8 mt-4 max-w-4xl overflow-hidden rounded-[1.75rem] bg-white"
                            style={{
                                boxShadow:
                                    "0 25px 70px color-mix(in srgb, var(--nf-brand-700) 14%, transparent)",
                            }}
                        >
                            {faqCards.map((item, index) => {
                                const isOpen = activeIndex === index;
                                return (
                                    <div
                                        key={item.questionKey || item.question || index}
                                        className={`border-b border-[var(--nf-brand-200)] ${
                                            index === faqCards.length - 1 ? "border-b-0" : ""
                                        }`}
                                    >
                                        <button
                                            type="button"
                                            onClick={() => setActiveIndex(isOpen ? -1 : index)}
                                            className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition  sm:px-6 sm:py-5"
                                            aria-expanded={isOpen}
                                        >
                    <span className="text-base font-semibold leading-7 text-[var(--nf-brand-950)] sm:text-lg">
                      {item.question || t(item.questionKey, language)}
                    </span>
                                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[var(--nf-brand-600)]">
                      {isOpen ? (
                          <Minus className="h-5 w-5" />
                      ) : (
                          <Plus className="h-5 w-5" />
                      )}
                    </span>
                                        </button>

                                        <div
                                            className={`grid overflow-hidden transition-all duration-300 ease-out ${
                                                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                            }`}
                                        >
                                            <div className="min-h-0">
                                                <div className="px-5 pb-5 sm:px-6">
                                                    <div className="rounded-2xl bg-[var(--nf-brand-50)] px-4 py-4 text-sm leading-7 text-[var(--nf-brand-800)] sm:text-base">
                                                        {item.answer || t(item.answerKey, language)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            ) : null}

            <div
                className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between gap-4 border-t bg-white px-4 py-3 shadow-[0_-8px_24px_rgba(15,23,42,0.08)] md:hidden"
                style={{ borderColor: config.borderColor }}
            >
                <div>
                    <p
                        className="text-xs font-medium uppercase"
                        style={{ color: config.mutedTextColor }}
                    >
                        {config.offerPriceLabel}
                    </p>
                    <p
                        className="text-lg font-black"
                        style={{ color: config.accentColor }}
                    >
                        {config.offerPriceCurrencySymbol} {formatPrice(orderTotal)}
                    </p>
                </div>
                <button
                    type="button"
                    onClick={handleOrderSubmit}
                    disabled={isSubmittingOrder}
                    className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-transform duration-200 hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-70"
                    style={primaryButtonStyle}
                >
                    {isSubmittingOrder ? "..." : config.orderNowLabel}
                    <ArrowRight className="h-4 w-4" />
                </button>
            </div>
            {whatsappHref ? (
                <a
                    href={whatsappHref}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Chat on WhatsApp"
                    className="fixed bottom-24 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform duration-200 hover:-translate-y-0.5 md:bottom-6"
                >
                    <svg
                        viewBox="0 0 32 32"
                        className="h-8 w-8"
                        fill="#ffffff"
                        aria-hidden="true"
                    >
                        <path d="M16.004 3C9.377 3 4 8.373 4 15c0 2.362.687 4.564 1.872 6.417L4 29l7.77-1.84A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3Zm0 21.818a9.77 9.77 0 0 1-4.99-1.37l-.358-.213-4.61 1.093 1.11-4.49-.234-.37A9.77 9.77 0 0 1 5.818 15c0-5.617 4.569-10.182 10.186-10.182 5.616 0 10.182 4.565 10.182 10.182 0 5.617-4.566 10.182-10.182 10.182Zm5.59-7.632c-.306-.153-1.81-.893-2.09-.994-.28-.102-.484-.153-.688.153-.204.306-.79.994-.968 1.198-.178.204-.357.23-.663.077-.306-.153-1.291-.476-2.46-1.518-.909-.81-1.523-1.81-1.701-2.116-.178-.306-.019-.472.134-.624.137-.137.306-.357.459-.535.153-.178.204-.306.306-.51.102-.204.051-.383-.026-.536-.077-.153-.688-1.658-.943-2.27-.248-.596-.5-.516-.688-.526-.178-.009-.383-.011-.586-.011-.204 0-.536.077-.816.383-.28.306-1.07 1.046-1.07 2.55 0 1.505 1.095 2.96 1.248 3.164.153.204 2.155 3.29 5.222 4.614.73.315 1.3.503 1.744.644.732.233 1.398.2 1.925.121.587-.088 1.81-.74 2.065-1.454.255-.714.255-1.326.178-1.454-.076-.128-.28-.204-.586-.357Z" />
                    </svg>
                </a>
            ) : null}
            {comboZoomImage ? (
                <div
                    className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 px-4"
                    onClick={() => setComboZoomImage(null)}
                >
                    <div
                        className="relative w-full max-w-lg overflow-hidden rounded-[1.5rem] bg-white shadow-2xl"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            type="button"
                            onClick={() => setComboZoomImage(null)}
                            aria-label="Close"
                            className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/50 text-white transition hover:bg-black/70"
                        >
                            <X className="h-5 w-5" />
                        </button>
                        {comboZoomImage.src ? (
                            <img
                                src={comboZoomImage.src}
                                alt={comboZoomImage.title || "Combo item"}
                                className="max-h-[70vh] w-full object-contain"
                            />
                        ) : null}
                        {comboZoomImage.title || comboZoomImage.shortNote ? (
                            <div className="bg-red-700 px-4 py-3 text-center">
                                {comboZoomImage.title ? (
                                    <p className="text-sm font-black text-white sm:text-base">
                                        {comboZoomImage.title}
                                    </p>
                                ) : null}
                                {comboZoomImage.shortNote ? (
                                    <p className="mt-1 text-xs font-bold text-white/90 sm:text-sm">
                                        {comboZoomImage.shortNote}
                                    </p>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : null}
            {showOrderConfirmModal ? (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4">
                    <div className="w-full max-w-md rounded-[1.5rem] bg-white p-6 text-center shadow-2xl sm:p-8">
                        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100">
                            <PartyPopper className="h-8 w-8 text-emerald-600" />
                        </div>
                        <p className="text-base font-semibold leading-7 text-[var(--nf-brand-950)] sm:text-lg">
                            অর্ডার কনফার্ম করা হয়েছে। খুব শীঘ্রই আমাদের প্রতিনিধি আপনার সাথে
                            যোগাযোগ করবেন। আরও পণ্য অর্ডার করতে আমাদের ওয়েবসাইট ভিজিট করুন।
                        </p>
                        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
                            <a
                                href="https://nabilfashion.com"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:-translate-y-0.5"
                                style={primaryButtonStyle}
                            >
                                Visit our website
                                <ArrowRight className="h-4 w-4" />
                            </a>
                            <button
                                type="button"
                                onClick={() => setShowOrderConfirmModal(false)}
                                className="inline-flex items-center justify-center rounded-full border px-6 py-3 text-sm font-semibold transition"
                                style={{ borderColor: config.borderColor, color: config.textColor }}
                            >
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
            <footer className="w-full bg-[#0b1120] px-4 py-6 text-center">
                <p className="text-xs text-slate-400 sm:text-sm">
                    © {new Date().getFullYear()} — MotionBooster. All rights reserved.
                </p>
                <a
                    href="https://motionbooster.com"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-2 inline-flex items-center justify-center gap-2 text-xs text-slate-400 transition hover:text-slate-200 sm:text-sm"
                >
                    Developed By Motionbooster
                    <img
                        src={motionBoosterLogo}
                        alt="Motion Booster"
                        className="h-5 w-auto"
                    />
                </a>
            </footer>
        </main>
    );
};

export default LandingPage;
